import {Component, Input, OnInit} from '@angular/core';
import {BookingEditorCampaignModel} from '../../../services/booking-editor/booking-editor.model';
import {BookingEditorService} from '../../../services/booking-editor/booking-editor.service';

@Component({
  selector: 'sb-campaign-overview',
  templateUrl: './sb-campaign-overview.component.html',
  styleUrls: ['./sb-campaign-overview.component.scss'],
  standalone: false,
})
export class SbCampaignOverviewComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  _campaignId: number;
  @Input() set campaignId(value: string) {
    this._campaignId = value ? Number(value) : null;
  }

  campaignOverview: BookingEditorCampaignModel | any;

  constructor(public bookingEditor: BookingEditorService) {}

  ngOnInit(): void {
    this.campaignOverview = this.bookingEditor.resourceStore.getById(this._campaignId);
  }
}
